import { useDispatch } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat } from '../common/function';
import dayjs from 'dayjs';

function SettlementPending() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        dispatch(change_Current_Location("정산보류내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPage(1)
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "가맹점", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement-pending", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 0, "text": "확정", "width": "50px", "textAlign": "center" },
        // { "no": 1, "text": "거래일자", "width": "100px", "textAlign": "center" },
        { "no": 1, "text": "보류일자", "width": "100px", "textAlign": "center" },
        { "no": 3, "text": "가맹점명", "width": "150px", "textAlign": "center" },
        { "no": 4, "text": "정산금액", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "수수료", "width": "100px", "textAlign": "center" },
        { "no": 6, "text": "실정산금액", "width": "100px", "textAlign": "center" },
        { "no": 7, "text": "정산형태", "width": "100px", "textAlign": "center" },
        { "no": 8, "text": "등록자명", "width": "100px", "textAlign": "center" },
    ];

    const [checkedIds, setCheckedIds] = useState([]);

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            let list = listTrxData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                let date = data.trx_date.split(' ')

                tableBodyData.push([
                    {
                        no: 0,
                        text: (
                            <input
                                type="checkbox"
                                checked={checkedIds.includes(data.id)} // ✅ 체크 상태 반영
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setCheckedIds(prev => [...prev, data.id]); // ✅ 체크 추가
                                    } else {
                                        setCheckedIds(prev => prev.filter(id => id !== data.id)); // ✅ 체크 해제
                                    }
                                }}
                            />
                        ),
                        width: "50px",
                        textAlign: "center",
                    },
                    { "no": 1, "text": date[0], "width": "100px", "textAlign": "center" },
                    { "no": 3, "text": data.co_nm, "width": "150px", "textAlign": "left" },
                    { "no": 4, "text": changeNum(Number(data.amt)), "width": "100px", "textAlign": "right" },
                    { "no": 5, "text": changeNum(Number(data.fee)), "width": "100px", "textAlign": "right" },
                    { "no": 6, "text": changeNum(Number(data.settlement_amt)), "width": "100px", "textAlign": "right" },
                    { "no": 7, "text": "익일", "width": "100px", "textAlign": "center" },
                    { "no": 8, "text": "관리자", "width": "100px", "textAlign": "center" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData, checkedIds])

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const ChangeCheckStatus = () => {
        if (window.confirm("저장하시겠습니까?") === true) {
            onChangeCheckStatus(checkedIds)
        }
    }

    const onChangeCheckStatus = async (arr) => {
        await axios.post(process.env.REACT_APP_API + "/api/settlement-pending/status", {
            id: arr,
            status: 1,
            reason: ""
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setCheckedIds([])
                setReload(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="button_wrap" style={{ marginTop: "0px" }}>
                            <button onClick={() => { ChangeCheckStatus() }} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px" }}>저장</button>
                        </div>
                    </div>
                    <div className='excel-disable'>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                    </div>
                </div>
                <div style={{ width: "100%", maxWidth: "900px" }}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"700px"}
                    />
                </div>
            </div>
        </div>
    )
}

export default SettlementPending